export const formatOrderCostDisplayValue = costValue => {
  if (costValue === undefined || costValue === null || costValue === "") {
    return "";
  }

  const normalizedCost = Math.trunc(Number(costValue));
  if (Number.isNaN(normalizedCost)) {
    return "";
  }

  return new Intl.NumberFormat("en-US").format(normalizedCost);
};

export const formatOrderCostDisplayLabel = costValue => {
  const formatted = formatOrderCostDisplayValue(costValue);

  return formatted ? `${formatted} đ` : "";
};

export const formatOrderCostMoney = raw => {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const parseOrderCostMoney = formatted =>
  String(formatted || "").replace(/\D/g, "");

export const toOrderCostThousandUnit = value =>
  Math.trunc(Number(value || 0) / 1000);

export const fromOrderCostThousandUnit = value => Number(value || 0) * 1000;
